import { getChannelOptions } from '../../MenuBoard/utils';
import { ChannelType, getActiveScreen } from 'src/modules/Redux';
import { useSelector } from 'react-redux';

export function useChannelOptions() {
    const activeScreen = useSelector(getActiveScreen);
    const channelOptions = getChannelOptions(
        ChannelType.CustomerPickupScreen,
        activeScreen
    );
    return { channelOptions };
}
